/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'groupBy'})
export class GroupByPropertyPipe implements PipeTransform {
    transform(collection: Array<any>, property: string): Array<any> {
        // prevents the application from breaking if the array of objects doesn't exist yet
        if(!collection) {
            return [];
        }

        const groupedCollection = collection.reduce((previous, current)=> {
            const prop = JSON.stringify(current[property]);
            if(!previous[prop]) {
                previous[prop] = [current];
            } else {
                previous[prop].push(current);
            }

            return previous;
        }, {});
        // this will return an array of objects, each object containing a group of objects
        return Object.keys(groupedCollection).map(ccGroupKey => ({ ccGroupKey, ccGroupValue: groupedCollection[ccGroupKey] }));
    }
}